
export const SolutionSection = () => {
  const solutions = [
    {
      icon: "ri-global-line",
      title: "Création de sites internet professionnels",
      description: "Sites web sur mesure, adaptés à votre image, votre business et vos envies pour refléter parfaitement votre identité"
    },
    {
      icon: "ri-search-eye-line",
      title: "Optimisation SEO et visibilité",
      description: "Référencement naturel optimisé pour être trouvé facilement sur Google avec domaine personnalisé et analytics intégrés"
    },
    {
      icon: "ri-smartphone-line",
      title: "Design responsive et mobile",
      description: "Sites parfaitement adaptés à tous les appareils et écrans pour une expérience utilisateur optimale"
    }
  ];

  return (
    <section id="solution-section" className="py-12 sm:py-16 md:py-20 bg-gradient-to-br from-purple-900 via-purple-800 to-pink-600 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10 sm:opacity-15">
        <div 
          className="w-full h-full bg-cover bg-center"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/4fef12a2215ae322c0e336fe119c5701.jpg')`
          }}
        />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-black mb-4 sm:mb-6 leading-tight">
            <span className="bg-gradient-to-r from-purple-300 via-pink-300 to-blue-300 bg-clip-text text-transparent">
              NOTRE SOLUTION
            </span>
          </h2>
          <div className="space-y-4">
            <p className="text-base sm:text-xl md:text-2xl text-purple-100 max-w-3xl mx-auto font-accent font-medium px-4 text-center">
              "Transformez votre présence en ligne"
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 mb-12 sm:mb-16">
          {solutions.map((solution, index) => (
            <div
              key={index}
              className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 sm:p-8 border border-white/20 hover:bg-white/20 transition-all duration-300 group"
            >
              <div className="w-14 h-14 sm:w-16 sm:h-16 bg-gradient-to-br from-pink-400 to-purple-400 rounded-full flex items-center justify-center mb-4 sm:mb-6 group-hover:scale-110 transition-transform duration-300 mx-auto md:mx-0">
                <i className={`${solution.icon} text-xl sm:text-2xl text-white`}></i>
              </div>
              <h3 className="text-lg sm:text-xl font-heading font-bold text-white mb-3 sm:mb-4 text-center md:text-left">
                {solution.title}
              </h3>
              <p className="text-purple-100 leading-relaxed font-primary text-sm sm:text-base text-center md:text-left">
                {solution.description}
              </p>
            </div>
          ))}
        </div>

        {/* Process Flow */}
        <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-6 sm:p-8 md:p-12 border border-white/20">
          <h3 className="text-xl sm:text-2xl md:text-3xl font-heading font-bold text-white text-center mb-8 sm:mb-12">
            Comment ça marche ?
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8">
            {[
              { step: "1", title: "Analyse", desc: "Nous analysons votre business et vos besoins" },
              { step: "2", title: "Création", desc: "Nous créons votre site internet sur mesure" },
              { step: "3", title: "Lancement", desc: "Mise en ligne et optimisation SEO" },
              { step: "4", title: "Résultats", desc: "Vous obtenez plus de visibilité et de clients" }
            ].map((item, index) => (
              <div key={index} className="text-center">
                <div className="w-14 h-14 sm:w-16 sm:h-16 bg-gradient-to-br from-pink-400 to-purple-400 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4 text-white font-heading font-bold text-lg sm:text-xl">
                  {item.step}
                </div>
                <h4 className="text-base sm:text-lg font-heading font-bold text-white mb-2">{item.title}</h4>
                <p className="text-purple-100 text-xs sm:text-sm font-primary px-2">{item.desc}</p>
              </div>
            ))}
          </div>
          
          {/* CTA Button for Appointment */}
          <div className="text-center mt-8 sm:mt-12">
            <button
              onClick={() => {
                const contactSection = document.getElementById('contact-section');
                if (contactSection) {
                  contactSection.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              className="bg-gradient-to-r from-pink-500 to-purple-500 hover:from-pink-600 hover:to-purple-600 text-white font-heading font-bold text-sm sm:text-base md:text-lg px-6 sm:px-8 py-3 sm:py-4 rounded-full shadow-xl transform hover:scale-105 transition-all duration-300 border-2 border-white/20 hover:border-white/40 whitespace-nowrap cursor-pointer w-full sm:w-auto max-w-sm mx-auto flex items-center justify-center"
            >
              <i className="ri-calendar-check-line mr-2 sm:mr-3 text-base sm:text-lg md:text-xl"></i>
              <span>Réserver un rendez-vous gratuit</span>
            </button>
          </div>

        </div>

      </div>
    </section>
  );
};
